define(function(require,exports,module){
	return function (num) {
        return (num).toFixed(4) * 1;
    }
});